import React from 'react';
import './App.css';
import './HeroSection.css';

function HeroSection() {
  return (
    <div className='hero-container'>
      <h1>Let's Move It.</h1>
      <p>What are you waiting for?</p>
    </div>
  );
}

export default HeroSection;